import React, {useState, useEffect, useRef} from 'react';
import { form_flow } from './../../userflows/fr';
import axios from "axios";
import { ConversationalForm as CForm } from 'conversational-form';
import './ConversationalForm.css';
import RightBot from '../../assets/RightBot.png';
import Avatar from '../../assets/avatar.png';
import qs from "qs";
//import { manUser } from '../../assets/man-user.svg';


 const ConversationalForm = () => {

  const elem = useRef();
  let cf = null;


    const [formFields, setFormFields] = useState(form_flow);

    //var inputField = document.getElementsByClassName("inputWrapper");
    //var fourChildNode = inputField[0].childNodes[1];
    //fourChildNode.placeholder = "Tapez votre réponse ici ...";

  useEffect(() => {
    cf = CForm.startTheConversation({
      options: {
        submitCallback: submitData,
        theme: 'RightCom',
        preventAutoFocus: true,
        hideUserInputOnNoneTextInput: true,
        // loadExternalStyleSheet: false
        loadExternalStyleSheet: false,
        userImage: Avatar,
        robotImage: RightBot,
        flowStepCallback: function(dto, success, error){
          // console.log("this is the dto ---> ", dto)

          if(dto.tag.name == "name"){
              if(dto.tag.value.toLowerCase() !== ""){
                  return success();
              }else{
                  return error();
              }
              //conversationalForm.stop("Stopping form, but added value");
          }
          else if(dto.tag.name == "email"){
              if(dto.tag.value.toLowerCase() !== ""){
                  return success();
              }else{
                  return error();
              }
          }
          else if(dto.tag.name == "mobile"){
            // To define the length of the phone number, set to 8 for Benin and 10 for Ivory Coast
              if(dto.tag.value.toLowerCase() !== ""){
                // console.log("this is dto", dto.text.length)
                // console.log("this is dto", dto.tag.value.length)
                  return success();
              }else{
                  return error();
              }
          }
          else if(dto.tag.name == "comment"){
            if(dto.tag.value.toLowerCase() !== ""){
              return success();
          }else{
              return error();
          }
          }


          return success();
      }
      },
      tags: formFields,



    }
    )
    ;
    elem.current.appendChild(cf.el);
  }, [formFields]);


  const submitData = () => {
    var formDataSerialized = cf.getFormData(true);

    formDataSerialized["language"] = "fr"
    if (Object.keys(formDataSerialized).indexOf("comment") === -1){
      formDataSerialized["comment"] = ""
    }
    const options = {
      headers: { "Content-Type": "application/json" },
    };
    console.log("Formdata, obj:", formDataSerialized);

    // return axios.post('/').then((s) =>{console.log(s)} ).catch(e=>{console.log(e)})
      return axios
        .post("https://rightbot.right-com.com/webhook/conversation/rightcombenin", formDataSerialized, {
          headers: {
               'content-type': 'application/json',
          },
      })
        .then((result) => {
          cf.addRobotChatResponse(result?.data["message"].replace("*", "").replace("*", ""));
          setTimeout(() => {
            // alert('Okay')
            window.location.reload();
          }, 10000)
        })
        .catch((error) => {
            // console.log(error)
            return { status: 400, error: error };
        });
  }

    return (
      <div style={{height: 100 + "vh"}} className="CForm">
        <div
          ref={elem}
        />
      </div>
    );

}

export default ConversationalForm;
